export default __webpack_public_path__ + "static/HelveticaNeueLTStd-MdCn-2f27fdae8f17e8045d6a06cd82c563ac.otf";